import React, {useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import {theme} from '../../styles';
import Slide from '@material-ui/core/Slide';
import LoginForm from '../LoginForm';
import RegistrationForm from '../RegistrationForm';
import AuthSuccess from './AuthSuccess';
import useUser from '../../hooks/useUser';

export interface AuthModalState {
    form: 'login' | 'register' | undefined;
    onUserAuthenticated?: () => void;
    analyticsContext: string | undefined;
}

interface AuthModalProps extends AuthModalState {
    setForm: (form: AuthModalState['form']) => void;
}

export default function AuthModal({
    form, onUserAuthenticated, analyticsContext, setForm,
}: AuthModalProps) {
    const [user] = useUser();

    useEffect(() => {
        if (user?.isAuthenticated) {
            setTimeout(() => {
                setForm(undefined);
                if (onUserAuthenticated) {
                    onUserAuthenticated();
                }
            }, 1500);
        }
    // We don't want to run this effect again if the value of "onUserAuthenticated" changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const slideContentStyle: React.CSSProperties = {
        width: '100%',
        height: '100%',
        // Must be absolute for smooth slide transition between login and registration forms,
        // but relative to ensure proper positioning of AuthSuccess
        position: user?.isAuthenticated ? 'relative' : 'absolute'
    };

    return (
        <Dialog
            open={Boolean(form)}
            onClose={() => setForm(undefined)}
            PaperProps={{style: {overflow: 'hidden'}}}
            // Make sure this draws above all other components
            style={{zIndex: 1501}}
        >
            <DialogContent
                style={{
                    padding: theme.spacing(4),
                    height: 425,
                    width: 339,
                    boxSizing: 'border-box',
                }}
            >

                <Slide
                    direction='left'
                    in={form === 'register'}
                    unmountOnExit
                    appear={false}
                    timeout={450}
                >
                    <div style={slideContentStyle}>
                        {user?.isAuthenticated && <AuthSuccess
                            in={Boolean(user?.isAuthenticated)}
                            message={'Thanks for joining!'}
                        />}
                        {!user?.isAuthenticated && <RegistrationForm
                            style={{position: 'absolute'}}
                            nextPage={window.location.pathname}
                            setForm={setForm}
                            analyticsContext={analyticsContext}
                        />}
                    </div>
                </Slide>

                <Slide
                    direction='right'
                    in={form === 'login'}
                    unmountOnExit
                    appear={false}
                    timeout={450}
                >
                    <div style={slideContentStyle}>
                        {user?.isAuthenticated && <AuthSuccess
                            in={Boolean(user?.isAuthenticated)}
                            message={'Welcome back!'}
                        />}
                        {!user?.isAuthenticated && <LoginForm
                            style={{position: 'absolute'}}
                            nextPage={window.location.pathname}
                            setForm={setForm}
                            analyticsContext={analyticsContext}
                        />}
                    </div>
                </Slide>

            </DialogContent>
        </Dialog>
    );
}
